/* eslint-disable  react/prop-types */

import React from 'react';

const OopsIcon = ({ width = 104, height = 104 }) => (
  <svg
    width="104"
    height="104"
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68 61.5L85.5 66"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M66.5 40L87.5 45.5V55.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M66 26.5L84.5 31.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M58 63L65.5 61"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M58 47V76"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M55.5 43L66 39.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M53 47V30.5L66 26.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M48 58V75.5L37 79"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M37.5 61L55.5 55.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M37 34.5L43 32.5V50L49 48"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M37 79L16 73"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M16 45.5V50.75V55.5L36 61"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <path
      d="M15.6333 29.2299C16.163 29.3863 16.7192 29.0838 16.8757 28.5542C17.0322 28.0245 16.7297 27.4683 16.2 27.3118L15.6333 29.2299ZM19.8667 28.3951C19.337 28.2387 18.7808 28.5412 18.6243 29.0708C18.4678 29.6005 18.7703 30.1567 19.3 30.3132L19.8667 28.3951ZM21.1333 30.8549C21.663 31.0113 22.2192 30.7088 22.3757 30.1792C22.5322 29.6495 22.2297 29.0933 21.7 28.9368L21.1333 30.8549ZM25.3667 30.0201C24.837 29.8637 24.2808 30.1662 24.1243 30.6958C23.9678 31.2255 24.2703 31.7817 24.8 31.9382L25.3667 30.0201ZM26.6333 32.4799C27.163 32.6363 27.7192 32.3338 27.8757 31.8042C28.0322 31.2745 27.7297 30.7183 27.2 30.5618L26.6333 32.4799ZM30.8667 31.6451C30.337 31.4887 29.7808 31.7912 29.6243 32.3208C29.4678 32.8505 29.7703 33.4067 30.3 33.5632L30.8667 31.6451ZM32.1333 34.1049C32.663 34.2613 33.2192 33.9588 33.3757 33.4292C33.5322 32.8995 33.2297 32.3433 32.7 32.1868L32.1333 34.1049ZM36.3667 33.2701C35.837 33.1137 35.2808 33.4162 35.1243 33.9458C34.9678 34.4755 35.2703 35.0317 35.8 35.1882L36.3667 33.2701ZM14.7167 28.959L15.6333 29.2299L16.2 27.3118L15.2833 27.041L14.7167 28.959ZM19.3 30.3132L21.1333 30.8549L21.7 28.9368L19.8667 28.3951L19.3 30.3132ZM24.8 31.9382L26.6333 32.4799L27.2 30.5618L25.3667 30.0201L24.8 31.9382ZM30.3 33.5632L32.1333 34.1049L32.7 32.1868L30.8667 31.6451L30.3 33.5632ZM35.8 35.1882L36.7167 35.459L37.2833 33.541L36.3667 33.2701L35.8 35.1882Z"
      fill="#00AED9"
    />
    <path d="M85 69L91 67.1237L85 62V69Z" fill="#00AED9" />
    <path
      d="M90.9061 52.7123L87.4061 57.8313L83.9061 50.8313L90.9061 52.7123Z"
      fill="#00AED9"
    />
    <path d="M85 35L91 33.1237L85 28V35Z" fill="#00AED9" />
    <path d="M55 73.9488L58.5 79L62 72L55 73.9488Z" fill="#00AED9" />
    <path d="M19 70L13 71.7828L19 77V70Z" fill="#00AED9" />
    <path d="M19 26L13 27.7828L19 33V26Z" fill="#00AED9" />
    <path d="M13 48.0305L16.5 43L20 50L13 48.0305Z" fill="#00AED9" />
    <path
      d="M51.9846 64.8982C51.5279 65.05 51.0328 65.0316 50.5883 64.8462C48.5122 63.9785 46.6692 62.6229 45.2117 60.891C43.7541 59.1592 42.7236 57.1008 42.2054 54.8857C42.2054 54.8597 42.2054 54.8181 42.2054 54.7921C42.0717 54.1697 42.0029 53.5348 42 52.8978C42 47.5637 46.5123 41.9695 52.0102 40.4083C57.5082 38.8471 62 41.9018 62 47.2047C61.9965 47.9241 61.9173 48.6411 61.7638 49.3435C61.7672 49.3818 61.7582 49.4202 61.7382 49.4528C60.5986 54.6568 57.693 59.7567 53.5708 63.9303L53.2577 64.2425C53.2577 64.2737 53.2064 64.2789 53.1807 64.3153C52.8315 64.5894 52.4344 64.7942 52.0102 64.919L51.9846 64.8982Z"
      fill="#00619E"
    />
    <path
      d="M50.347 53.5822V52.7844C50.347 51.1888 53.0745 49.7571 53.0745 48.5385C53.0745 47.9484 52.4425 47.5877 51.594 47.8172C50.2046 48.1888 49.8287 49.4894 49.3162 49.1997L48.109 48.3855C47.9553 48.2981 47.9723 48.0631 48.109 47.8937C49.1149 46.5986 50.5222 45.6421 52.1293 45.1615C54.2249 44.6151 56.1667 45.4785 56.1667 47.3965C56.1667 49.9046 53.1999 50.7789 53.1999 52.8281C53.1899 52.9318 53.1492 53.0307 53.0826 53.113C53.016 53.1953 52.9263 53.2576 52.824 53.2926L50.7057 53.839C50.664 53.8509 50.62 53.8533 50.5772 53.846C50.5344 53.8388 50.4939 53.822 50.4591 53.797C50.4242 53.7721 50.396 53.7396 50.3765 53.7023C50.357 53.665 50.3469 53.6239 50.347 53.5822ZM51.7706 55.3089C51.9871 55.2302 52.2206 55.2041 52.4502 55.2332C52.6798 55.2622 52.8983 55.3454 53.0862 55.4754C53.274 55.6053 53.4254 55.7779 53.5267 55.9777C53.6281 56.1775 53.6762 56.3983 53.6668 56.6204C53.6282 57.1416 53.4266 57.6396 53.0882 58.0491C52.7499 58.4586 52.2907 58.7605 51.7706 58.9154C51.5582 58.992 51.3294 59.0171 51.1046 58.9885C50.8797 58.9599 50.6657 58.8785 50.4815 58.7514C50.2973 58.6244 50.1486 58.4557 50.0486 58.2603C49.9486 58.0649 49.9005 57.8489 49.9085 57.6313C49.9405 57.1097 50.1352 56.6094 50.4672 56.1952C50.7993 55.7811 51.2534 55.4723 51.7706 55.3089Z"
      fill="white"
    />
    <path
      d="M96 93L66 85.0488V11L96 18.9512V93Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66 84.7352L37 93V19.2648L66 11V84.7352Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37 93L8 84.6479V11L37 19.3473V93Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 91.5L22 96"
      stroke="#00AED9"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M83 8L98 12"
      stroke="#00AED9"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M32 10.2L37.2 12L44 9.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71 94L65.8 92.5L59 94.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OopsIcon;
